import FullTextSearch from './FullTextSearch';
export default FullTextSearch;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SubHeader/FullTextSearch/index.js